import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export default function QRVerify() {
  const { token } = useParams();
  const [r, setR] = useState(null);
  useEffect(() => {
    if (token === "demo") { setR({ demo: true }); return; }
    api.get(`/verify/${token}`).then((res) => setR(res.data)).catch(() => setR({ valid: false }));
  }, [token]);

  if (!r) return <div className="min-h-screen bg-[#0F0F10] text-[#FBF9F5] flex items-center justify-center">Verifying…</div>;

  if (r.demo) {
    return (
      <div className="min-h-screen bg-[#0F0F10] text-[#FBF9F5] flex items-center justify-center px-6 py-12">
        <div className="max-w-lg text-center">
          <p className="eyebrow text-[#C5A059]">Authenticity</p>
          <h1 className="font-serif text-4xl mt-4">This is how verification looks.</h1>
          <p className="mt-4 text-[#8C867D]">Every LEE BAG carries a unique QR. Scan it to see the artisan's signature, the piece's serial, and (with owner consent) their photograph.</p>
        </div>
      </div>
    );
  }

  if (!r.valid) {
    return (
      <div className="min-h-screen bg-[#0F0F10] text-[#FBF9F5] flex flex-col items-center justify-center px-6">
        <XCircle size={48} className="text-[#5B1C22]" />
        <p className="eyebrow text-[#5B1C22] mt-6">LEE BAG</p>
        <h1 className="font-serif text-3xl mt-2">Verification Failed</h1>
        <p className="text-[#8C867D] mt-4 text-center">This QR could not be authenticated by the LEE BAG system.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0F0F10] text-[#FBF9F5] px-6 py-12" data-testid="qr-verify-page">
      <div className="max-w-3xl mx-auto text-center">
        <div className="font-serif text-3xl tracking-[0.4em]">LEE BAG</div>
        <p className="eyebrow text-[#C5A059] mt-4">Certificate of Authenticity</p>
        <div className="mt-6 flex items-center justify-center gap-2 text-[#C5A059]"><CheckCircle2 size={20} /> <span className="text-sm uppercase tracking-widest">Authenticated</span></div>

        <div className="grid md:grid-cols-2 gap-8 mt-12">
          <div className="border border-[#27272A] p-8 bg-[#18181B]">
            <p className="eyebrow text-[#C5A059] mb-4">Verified Owner</p>
            {r.customer_photo ? (
              <img src={r.customer_photo} alt="owner" className="w-48 h-48 mx-auto object-cover" data-testid="qr-cert-customer-photo" />
            ) : (
              <div className="w-48 h-48 mx-auto bg-[#27272A] flex items-center justify-center text-xs text-[#8C867D] text-center px-4">Owner chose to keep their photo private</div>
            )}
            {r.customer_name && <p className="mt-4 font-serif text-xl">{r.customer_name}</p>}
          </div>
          <div className="border border-[#27272A] p-8 bg-[#18181B]">
            <p className="eyebrow text-[#C5A059] mb-4">Verified Product</p>
            <img src={r.product_image} alt={r.product_name} className="w-48 h-48 mx-auto object-cover" data-testid="qr-cert-product-photo" />
            <p className="mt-4 font-serif text-xl">{r.product_name}</p>
            <p className="font-mono text-xs text-[#8C867D] mt-1">Unit · {r.unit_id}</p>
          </div>
        </div>

        <div className="mt-12 text-xs uppercase tracking-[0.3em] text-[#8C867D]">
          Issued {new Date(r.issued_at).toLocaleDateString()} · LEE BAG · Handcrafted in India
        </div>
      </div>
    </div>
  );
}
